export default __webpack_public_path__ + "static/media/Contact.23b53f4d.jpg";